import { createFileRoute } from '@tanstack/react-router';

import { ensureMediaQueryData } from '@/api/media';

export const Route = createFileRoute(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/new'
)({
  loader: ensureMediaQueryData,
});
